import { afterNextRender, ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Consent } from '@core/services';

/**
 * Banner de consentimiento de cookies/analítica.
 *
 * Se muestra solo si el usuario aún no ha tomado una decisión. Al aceptar o
 * rechazar, delega en el servicio {@link Consent} que persiste la elección y
 * envía la señal a Google Consent Mode v2.
 */
@Component({
  selector: 'app-cookie-banner',
  imports: [TranslateModule, RouterModule],
  templateUrl: "./cookie-banner.component.html",
  styleUrl: "./cookie-banner.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieBanner {
  private readonly consent = inject(Consent);

  /** Controla la visibilidad del banner (solo se evalúa en el navegador). */
  protected readonly visible = signal(false);

  constructor() {
    // Se evalúa tras la hidratación para evitar mismatch SSR/cliente.
    afterNextRender(() => this.visible.set(!this.consent.hasDecision()));
  }

  /** Acepta la analítica y oculta el banner. */
  protected accept(): void {
    this.consent.accept();
    this.visible.set(false);
  }

  /** Rechaza la analítica y oculta el banner. */
  protected reject(): void {
    this.consent.reject();
    this.visible.set(false);
  }
}
